const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网首发',
    desc: '7×24小时监控热点，重大黑料事件30分钟内上线，比所有竞品都快一步。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多源验证',
    desc: '每条信息经过至少3个独立信源交叉验证后才发布，拒绝虚假爆料和恶意造谣。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '匿名保护',
    desc: '采用端到端加密技术保护爆料人信息，绝不向任何第三方泄露投稿人身份。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量存档',
    desc: '收录超过10万条历史黑料，支持关键词检索与时间线回溯，吃瓜不留遗憾。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么百万吃瓜群众选择911吃瓜网
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f) => (
            <div key={f.title} className="text-center p-6 bg-background-100 rounded-xl border border-secondary-200/60 hover:border-primary-200 transition-all duration-200">
              <span className="w-13 h-13 flex items-center justify-center mx-auto bg-primary-100 text-primary-600 rounded-2xl mb-4">
                <i className={`${f.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm font-medium text-foreground-800 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}